import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectIsDocDrafter = createSelector(
  (state: RootState) => state.user.isDocDrafter,
  (isDocDrafter: boolean) => isDocDrafter
)

export default selectIsDocDrafter
